/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Component } from '@/Constants/Component'

/**************************************************************************************************/
/** @internal Const @name ModuleBox                                                              **/
/**************************************************************************************************/
const SubmitButton = defineComponent(
{
	/*************************************************/
	/** @Properties                                 **/
	/*************************************************/
	name: 'SubmitButton',

	props:
	{
		action: { type: Number, default: Component.Actions.INSERT },
		isDisabled: Boolean,
		isFetching: Boolean,
		onInsertText: { type: String, default: 'Registrar' },
		onReadText: { type: String, default: 'Leer' },
		onUpdateText: { type: String, default: 'Actualizar' },
		variant: { type: String, default: 'green' }
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		GetText() : string
		{
			const { action, onInsertText, onUpdateText } = this.$props
			return action === Component.Actions.INSERT ? onInsertText : onUpdateText
		}
	}
})

/**************************************************************************************************/
/** @export Component @name SubmitButton                                                         **/
/**************************************************************************************************/
export default SubmitButton

/**************************************************************************************************/
/** @export Type @name SubmitButtonRef                                                           **/
/**************************************************************************************************/
export type SubmitButtonRef = InstanceType<typeof SubmitButton>